<div class="row mb-3 casedataalignment" [ngClass]="{'mb-3 border-bottom-div':borderbottom,'m-0':alinemet}">
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 pt-3 pl-lg-5">
      <!-- User Profile Icon -->
      <img
        src="{{
          RESOURCE_SERVER_URL +
            '/assets/images/Underwriting_new/Underwriting/Analyse Report/User.svg'
        }}"
        alt=""
      />
    </div>
   <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 px-md-0 pt-3">
    <div class="casedataalignment">
    <div class="row p-0">
      <div class="col-md-5 col-12 p-0">
        <span class="propsaldetail">{{ findkeyLabel(insuredDetail.summary.insuredTitleKey,'Title') }}{{insuredDetail.summary.insuredTitleKey?'.':''}}{{ insuredDetail.summary.insuredFullName }}{{insuredDetail.summary.insuredClientId?',':''}} {{ insuredDetail.summary.insuredClientId }}</span>
        <div class="proposaldata">
          <span>{{ insuredDetail.summary.insuredAge }}{{insuredDetail.summary.insuredGenderKey?', ':''}}{{findkeyLabel(insuredDetail.summary.insuredGenderKey,'Gender')}}{{insuredDetail.summary.insuredMaritalStatus?', ':''}}{{ findkeyLabel(insuredDetail.summary.insuredMaritalStatus,'MaritalStatus') }} </span>
        </div>
      </div>
       <div class="col-md-7 col-12 d-md-flex"> 
      <ng-container *ngIf="showMessages">
      <div class="col-md-5 col-12 apply-warning-message pl-0">
        <p class="warning-message">{{ insuredDetail.summary.uwJetRules[0] | translate }}<img *ngIf="!reminingmessages" class="" src="{{  RESOURCE_SERVER_URL +'/assets/images/prev.svg' }}" alt="Prev Icon" (click)="showReminingmessages()"/> <span *ngIf="reminingmessages" (click)="showReminingmessages()"><b>X</b></span>
        </p>
        <ng-container *ngIf="reminingmessages && insuredDetail.summary.uwJetRules.length > 1">
          <ng-container  *ngFor="let item of insuredDetail.summary.uwJetRules let i=index">
            <p class="warning-message" *ngIf="i!=0">{{item}}</p>
        </ng-container>
        </ng-container>
      </div>
      </ng-container>
      <ng-container *ngIf="validationmessage && showMessages">
      <div class="col-md-7 col-12  apply-warning-message px-0">
          <p class="validation-message warning-message">There is no sanctions found for this customer<img *ngIf="!validationreminingMesages" class="" src="{{  RESOURCE_SERVER_URL +'/assets/images/prev.svg' }}" alt="Prev Icon" (click)="showvalidationReminingmessages()"/> <span *ngIf="validationreminingMesages" (click)="showvalidationReminingmessages()"><b>X</b></span>
          </p>
          <ng-container *ngIf="validationreminingMesages && insuredDetail.summary.uwJetRules.length > 1">
            <ng-container  *ngFor="let item of insuredDetail.summary.uwJetRules let i=index">
              <p class="validation-message warning-message" *ngIf="i!=0">{{item}}</p>
          </ng-container>
          </ng-container>
      </div>
    </ng-container>
    </div>
    </div>

    <div class="row pb-3 pt-3">
    <div class="col-10 view-details d-md-flex p-0">
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 pl-0">
        <span>{{ "label.casereview.dob" | translate }} <img alt="BOD Icon" (click)="showhelpdetails('label.casereview.dob','dob')" id= "dob" class='help-icons' *ngIf="isVisible && helplabel.label.dob != undefined" [src]="helpicon"></span>
            <p>{{ insuredDetail.summary.insuredDateOfBirth==''?'-':dateFormeting(insuredDetail.summary.insuredDateOfBirth)}}</p>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <span>{{ "label.casereview.race" | translate }} <img alt="Race Icon" (click)="showhelpdetails('label.casereview.race','race')" id= "race" class='help-icons' *ngIf="isVisible && helplabel.label.race != undefined" [src]="helpicon"></span>
        <p>{{dataisemity(findkeyLabel(insuredDetail.summary.insuredRace,'RaceInformation')) }}</p>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <span>{{ "label.casereview.tob" | translate }} <img alt="Tobacco Icon" (click)="showhelpdetails('label.casereview.tob','tob')" id= "tob" class='help-icons' *ngIf="isVisible && helplabel.label.tob != undefined" [src]="helpicon"></span>
        <p>{{ dataisemity(findkeyLabel(insuredDetail.summary.insuredMortality,'SmokerStatus'))}}</p>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <span>{{ "label.casereview.bmi" | translate }} <img alt="BMI Icon" (click)="showhelpdetails('label.casereview.bmi','bmi')" id= "bmi" class='help-icons' *ngIf="isVisible && helplabel.label.bmi != undefined" [src]="helpicon"></span>
        <p>{{ dataisemity(insuredDetail.summary.insuredBmi) }}</p>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 pl-0">
        <span>{{ "label.casereview.id" | translate }} <img alt="ID Image" (click)="showhelpdetails('label.casereview.id','id-help')" id= "id-help" class='help-icons' *ngIf="isVisible && helplabel.label.id != undefined" [src]="helpicon"></span>
        <p>{{ dataisemity(insuredDetail.summary.insuredIdNumber) }}</p>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <span>{{ "label.casereview.idtype" | translate }} <img alt="ID Type Icon" (click)="showhelpdetails('label.casereview.idtype','idtype')" id= "idtype" class='help-icons' *ngIf="isVisible && helplabel.label.idtype != undefined" [src]="helpicon"></span>
        <p>{{ dataisemity(findkeyLabel(insuredDetail.summary.insuredIdType,'clientIdTypes')) }}</p>
      </div>
    </div>
  </div>
    </div>
   </div>

    <div class="col-xl-1 col-lg-1 col-md-1 col-sm-12 px-0 text-right">
      <!-- Button Download -->
      <custom-button mode="text" margin="xsmall" *ngIf="!showMessages"  iconSrc="{{
        RESOURCE_SERVER_URL +
          '/assets/images/Underwriting_new/Underwriting/Undwerting Queue/Download.svg'
      }}">
      </custom-button>
      <custom-button *ngIf="showMessages"
    applyclass="pr-1 secondarybutton remove-button-shadow msg-class"
    mode="secondary"
    margin="xsmall"
    size="small"
    [iconSrc]="msgPath"
    iconPosition="after"
    (onClick)="showValidationMessage()"
  >
  </custom-button>
    </div>
  </div>


